import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import StyledSearchDate from './StyledSearchDate';
import LoadingSpinner from './LoadingSpinner';
import { ajaxGetPartStatistics } from '../services/partComponentService';
import { toDateText, priceFormat } from '../helpers';

export default function PartComponentStatisticDialog(props) {
  const { open, onClose, partComponent } = props;

  const [loading, setLoading] = useState(false);
  const [statistics, setStatistics] = useState([]);
  const [startDate, setStartDate] = useState(moment().add(-1, 'M').startOf('day').unix());
  const [endDate, setEndDate] = useState(moment().endOf('day').unix());

  useEffect(() => {
    if (open) {
      setLoading(true);
      ajaxGetPartStatistics(partComponent.id, { startTime: startDate, endTime: endDate })
        .then((res) => {
          setStatistics(res.data);
          setLoading(false);
        })
        .catch(() => {
          setStatistics([]);
          setLoading(false);
        });
    }
  }, [open, startDate, endDate, partComponent.id]);

  const totalQuantity = statistics.reduce((sum, item) => sum + item.quantity, 0);
  const averagePrice = statistics.length > 0 
    ? statistics.reduce((sum, item) => sum + (item.price * item.quantity), 0) / totalQuantity 
    : 0;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">{partComponent.manuf_part_number}</DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid xs={12} item sx={{ mt: '6px' }}>
            <StyledSearchDate
              startDate={startDate}
              endDate={endDate}
              onStartDate={setStartDate}
              onEndDate={setEndDate}
              gridProps={{ columnSpacing: 1 }}
            />
          </Grid>
          <Grid xs={12} item sx={{ minHeight: '80px', position: 'relative' }}>
            {loading ? (
              <LoadingSpinner />
            ) : (
              <div style={{ marginTop: "12px" }}>
                <strong>Statistics Summary:</strong>
                <ul>
                  <li>Total Quantity: {totalQuantity}</li>
                  <li>Average Price: {priceFormat(averagePrice, 2, 2)}</li>
                </ul>
                {statistics.length > 0 && (
                  <TableContainer sx={{ maxHeight: 400, mt: "12px" }}>
                    <Table stickyHeader size="small" aria-label="part component statistics table">
                      <TableHead>
                        <TableRow>
                          <TableCell>PO Date</TableCell>
                          <TableCell>PO Number</TableCell>
                          <TableCell align='right'>Price</TableCell>
                          <TableCell align='right'>Quantity</TableCell>
                          <TableCell align='right'>Total</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {statistics.map((stat, index) => (
                          <TableRow key={index}>
                            <TableCell>{toDateText(stat.po_date)}</TableCell>
                            <TableCell>{stat.po_number}</TableCell>
                            <TableCell align='right'>{priceFormat(stat.price, 2, 6 )}</TableCell>
                            <TableCell align='right'>{stat.quantity}</TableCell>
                            <TableCell align='right'>{priceFormat(stat.price * stat.quantity, 2, 6)}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </div>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
} 